import React from "react";
import styles from "./essencesaudelongevidade.module.scss";
import logoImg from "./src/logo.png";
import perfilImg from "./src/perfil.png";
import { FaWhatsapp } from "react-icons/fa";

const Essencesaudelongevidade: React.FC = () => {

    return (
        <div className={styles.essencesaudelongevidade}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <img src={logoImg} alt="Logo Essence Saúde e Longevidade" className={styles.logo} />
                    <img src={perfilImg} alt="Perfil" className={styles.perfil} />
                </div>
                <div className={styles.body}>
                    <nav className={styles.links}>
                        <a
                            href="https://wa.me/5517997690033?text=Olá, gostaria de agendar uma consulta."
                            className={styles.linkBtn}
                            aria-label="Agendar consultas"
                        >
                            <span>Agendar consultas</span>
                        </a>
                        <a
                            href="https://maps.app.goo.gl/rh71TzKpqi6FQYnY6"
                            className={styles.linkBtn}
                            aria-label="Localização"
                        >
                            <span>Localização</span>
                        </a>
                        <a
                            href="https://www.instagram.com/essencesaudelongevidade?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            className={styles.linkBtn}
                            aria-label="Instagram"
                        >
                            <span>Instagram</span>
                        </a>
                        <a
                            href="https://drapatriciaandradeestetica.com.br/"
                            className={styles.linkBtn}
                            aria-label="Site"
                        >
                            <span>Site</span>
                        </a>
                        <a
                            href="https://api.whatsapp.com/send/?phone=5538991570858&text&type=phone_number&app_absent=0"
                            className={styles.linkBtn}
                            aria-label="Fale com Dr. Mesaque"
                        >
                            <span>Fale com Dr. Mesaque</span>
                        </a>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default Essencesaudelongevidade;
